<template>
    <div class="CouponItem">
        <div class="CouponItem-iconContainer">
            <span
                class="CouponItem-icon"
                :class="{
                    'f2m-rounded-percent': coupon.type === 'percentage',
                    'f2m-rounded-dollar': coupon.type !== 'percentage'
                }"
            />
        </div>
        <div class="CouponItem-infoContainer">
            <div class="CouponItem-title">
                {{ title }}
                <!--                - 10 € on your rent-->
            </div>
            <div
                v-if="coupon.quota && coupon.type !== 'credit'"
                class="CouponItem-usable"
            >
                {{ $t('personal-account.couponItem.usable', { count: coupon.quota }) }}
                <!--                Usable 3 times -->
            </div>
            <div
                v-if="coupon.to"
                class="CouponItem-availability"
            >
                {{ availability }}
                <!--                Available untill 31/12/2021-->
            </div>
            <div class="CouponItem-code">
                {{ $t('personal-account.couponItem.code') }} : {{ coupon.discountCode }}
                <!--                Code : 01W8SDZY0E -->
            </div>
        </div>
    </div>
</template>
<script>
import dayjs from "dayjs";
import money from "@free2move/money";
export default {
    props: {
        coupon: {
            type: Object,
            required: true
        }
    },
    computed: {
        title() {
            return this.$t('personal-account.couponItem.title', { amount: this.amount, serviceType: this.$t('personal-account.couponItem.service.'+this.serviceType) });
        },
        availability() {
            return this.$t('personal-account.couponItem.availability', { date: dayjs(this.coupon.to).format('L') });
        },
        amount() {
            switch(this.coupon.type) {
                case 'percentage':
                    return `${this.coupon.percentage}%`;
                case 'fixed':
                    return new money({...this.coupon.fixed, language: this.$language}).format();
                case 'credit':
                    return new money({...this.coupon.credit, language: this.$language}).format();
                default:
                    return '';
            }
        },
        serviceType() {
            return this.coupon.modelId.split('-')[0]
        }
    }
}
</script>
<style lang="scss" scoped>
.CouponItem {
    display: flex;
    align-items: flex-start;
    gap: 8px;
    &-title {
        font-weight: bold;
        font-size: 22px;
        line-height: 26px;
        color: $color-f2m-blue;
    }
    &-icon {
        font-size: 24px;
    }
    &-infoContainer {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        gap: 5px
    }
    &-availability {
        font-size: 14px;
        line-height: 17px;
        color: $color-f2m-purple;
    }
    &-code {
        font-size: 14px;
        line-height: 17px;
        color: $color-f2m-purple-icon;
    }
    &-usable {
        background: linear-gradient(266.35deg, #00D7CA 3.55%, #00D7A3 86.37%);
        border-radius: 9px;
        padding: 1px 5px 3px;
        font-size: 12px;
        line-height: 14px;
        color: $color-white;
    }
}
</style>
